module.exports = __webpack_public_path__ + "static/media/finger.98e91e05.png";